"use strict";

/**
 * Clase `Convalidation` para gestionar los campos relacionados a la convalidación.
 */
export class Convalidation {
    /**
     * Crea una instancia de la clase Convalidation.
     * @param {Object} notification - Objeto para manejar notificaciones.
     * @param {Object} httpError - Objeto para manejar errores HTTP.
     * @param {Object} tool - Objeto para métodos auxiliares
     */
    constructor(notification, httpError, tool) {
        this.notification = notification;
        this.httpError = httpError;
        this.tool = tool;
    }

    /**
     * Confirma antes de cambiar el estado de un usuario
     */
    changeUser() {
        document.querySelectorAll(".changeUser").forEach((item) => {
            item.addEventListener("click", async () => {
                const userId = item.getAttribute("id");

                const question = this.notification.showSwalConfirm(
                    "¡No!",
                    "#E3051B",
                    "Sí, procede",
                    "<p class='m-0 text-center'></p>",
                    "warning",
                    "<p class='m-0 text-center'>¿Realmente desea cambiar el estado de este usuario?</p>"
                );

                try {
                    const result = await question;

                    if (result.value) {
                        const response = await axios.put(
                            `/admin/users/${userId}/active`,
                            { userId }
                        );

                        this.notification.showToasted(
                            "alive",
                            "success",
                            `<p class='p-0'>${response.data}</p>`
                        );
                        setTimeout(
                            () => (location.href = `/admin/users`),
                            1500
                        );
                    } else {
                        this.notification.showToasted(
                            "alive",
                            "error",
                            "<p class='m-0 text-center'>El usuario seleccionado no ha sido afectado.</p>"
                        );
                    }
                } catch (error) {
                    this.httpError.handleHttpError(error);
                }
            });
        });
    }

    /**
     * Habilita/deshabilita los campos de convalidación en el formulario de creación.
     */
    recognitionOnCreate() {
        this.setupRecognition("#form_record", false);
    }

    /**
     * Habilita/deshabilita los campos de convalidación en el formulario de edición.
     */
    recognitionOnEdit() {
        this.setupRecognition("#form_record_edit", true);
    }

    /**
     * Configura el comportamiento de los campos de convalidación según el formulario.
     * @param {string} formSelector - Selector del formulario (creación o edición).
     */
    setupRecognition(formSelector, isEditMode = false) {
        const selectors = [
            formSelector,
            "#section_recognition",
            "#is_validation_1",
            "#is_validation_2",
        ];

        if (!this.tool.areElementsPresent(selectors)) return;

        const sectionRecognition = document.querySelector(
            "#section_recognition"
        );
        const validationRadios = document.querySelectorAll(".is_validation");
        const isValidation1 = document.querySelector("#is_validation_1");

        const fields = {
            dateResolution: document.querySelector("#date_resolution"),
            menDocument: document.querySelector("#men_document"),
            numberResolution: document.querySelector("#number_resolution"),
            validatedDegree: document.querySelector("#validated_degree"),
            divDateResolution: document.querySelector("#div_date_resolution"),
            divMenDocument: document.querySelector("#div_men_document"),
            divNumberResolution: document.querySelector(
                "#div_number_resolution"
            ),
            divValidatedDegree: document.querySelector("#div_validated_degree"),
        };

        /** Estado inicial al cargar */
        this.toggleRecognitionFields(
            isValidation1.checked,
            fields,
            sectionRecognition,
            isEditMode,
            true
        );

        /** Escucha los cambios en opciones de validación */
        validationRadios.forEach((radio) => {
            radio.addEventListener("change", (event) => {
                this.toggleRecognitionFields(
                    event.target.value == 1,
                    fields,
                    sectionRecognition,
                    isEditMode,
                    false
                );
            });
        });
    }

    /**
     * Muestra u oculta los campos de convalidación y define si son obligatorios.
     * @param {boolean} shouldShow - Indica si se deben mostrar los campos.
     * @param {Object} fields - Elementos HTML de los campos y contenedores.
     * @param {HTMLElement} sectionRecognition - Contenedor de la sección de reconocimiento.
     * @param {boolean} isEditMode - Indica si el formulario es de edición.
     * @param {boolean} isInitialLoad - Indica si se está en la carga inicial.
     */
    toggleRecognitionFields(
        shouldShow,
        fields,
        sectionRecognition,
        isEditMode,
        isInitialLoad
    ) {
        const show = (element) => {
            element.classList.remove("hidden");
            element.classList.add("md:grid");
        };

        const hide = (element) => {
            element.classList.add("hidden");
            element.classList.remove("md:grid");
        };

        if (shouldShow) {
            show(sectionRecognition);
            show(fields.divMenDocument);
            show(fields.divDateResolution);
            show(fields.divNumberResolution);
            show(fields.divValidatedDegree);

            /** Solo en creación o en cambio dinámico en edición, el archivo es requerido */
            if (!isEditMode || (isEditMode && !isInitialLoad)) {
                fields.menDocument.required = true;
            }

            fields.dateResolution.required = true;
            fields.numberResolution.required = true;
            fields.validatedDegree.required = true;
        } else {
            hide(sectionRecognition);
            hide(fields.divMenDocument);
            hide(fields.divDateResolution);
            hide(fields.divNumberResolution);
            hide(fields.divValidatedDegree);

            fields.menDocument.required = false;
            fields.dateResolution.required = false;
            fields.numberResolution.required = false;
            fields.validatedDegree.required = false;
        }
    }
}
